<template>
  <div class="cpc-create">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
    </breadcrumbs>

    <!-- <h2 class="title">{{ pageTitle }}</h2> -->


    <a-steps :current="currentStep" class="steps">
      <a-step v-for="(titleKey, idx) in CPC_CREATE_STEP_TITLE_KEYS" :key="titleKey" :title="$t(titleKey)">
        <template #icon>
          <span class="cpc-step-index">{{ idx + 1 }}</span>
        </template>
      </a-step>
    </a-steps>
    <noticeTool />
    <!-- <div class="notice">
        <p>Notice:</p>
        <p>1. The campaign will automatically end when the end time is reached or the budget cap is met.</p>
        <p>2. Different budget caps can be set for different publishers.</p>
      </div> -->
    <div class="panel">
      <div v-show="currentStep === 0" class="form">
        <div class="form-title">
          {{ $t('seller.cpcCreate.formTitleStep1') }}
        </div>
        <div class="form-content">


          <div class="field field-title" :class="{ 'field-error': !!step1Errors.title }">
            <label>{{ $t('seller.cpcCreate.labelTitle') }}<span class="label-required">*</span></label>
            <div class="title-input-row">
              <a-input class="title-input" v-model:value="form.title" :maxlength="100" show-count />
              <!-- <span class="tips">({{ form.title.length }}/100)</span> -->
            </div>
            <p v-if="step1Errors.title" class="field-error-text">{{ step1Errors.title }}</p>
          </div>

          <div class="field with-suffix" :class="{ 'field-error': !!step1Errors.totalBudget }">
            <label>{{ $t('seller.cpcCreate.labelTotalBudget') }}<span class="label-required">*</span></label>
            <div>
              <a-input-number class="title-input budget-input" v-model:value="form.totalBudget" :min="1" :precision="0"
                :controls="false" style="width: 100%;margin-top: 8px;" :maxlength="10">
                <template #prefix>
                  {{ currency }}
                </template>
              </a-input-number>
              <p v-if="step1Errors.totalBudget" class="field-error-text">{{ step1Errors.totalBudget }}</p>
            </div>

            <!-- <span class="suffix">{{ currency }}</span> -->

          </div>

          <div class="field with-suffix" :class="{ 'field-error': !!step1Errors.publisherTotalCap }">
            <label>
              {{ $t('seller.cpcCreate.labelPublisherTotalCap') }}<span class="label-required">*</span>
              <small>{{ $t('seller.cpcCreate.hintPublisherTotalCap') }}</small>
            </label>
            <a-input-number v-model:value="form.publisherTotalCap" :min="1" :precision="0" :controls="false"
              class="title-input budget-input" style="width: 100%;margin-top: 8px;">
              <template #prefix>
                {{ currency }}
              </template>
            </a-input-number>

            <p v-if="step1Errors.publisherTotalCap" class="field-error-text">{{ step1Errors.publisherTotalCap }}</p>
          </div>

          <div class="field with-suffix" :class="{ 'field-error': !!step1Errors.publisherDailyCap }">
            <label>
              {{ $t('seller.cpcCreate.labelPublisherDailyCap') }}<span class="label-required">*</span>
              <small>{{ $t('seller.cpcCreate.hintPublisherDailyCap') }}</small>
            </label>
            <a-input-number v-model:value="form.publisherDailyCap" :min="1" :precision="0" :controls="false"
              class="title-input budget-input" style="width: 100%;margin-top: 8px;">
              <template #prefix>
                {{ currency }}
              </template>
            </a-input-number>
            <!-- <span class="suffix">{{ currency }}</span> -->
            <p v-if="step1Errors.publisherDailyCap" class="field-error-text">{{ step1Errors.publisherDailyCap }}</p>
          </div>

          <div class="row">
            <div class="field" :class="{ 'field-error': !!step1Errors.startDate }">
              <label>{{ $t('seller.cpcIndex.colStartDate') }}<span class="label-required">*</span></label>
              <a-date-picker v-model:value="form.startDate" style="width: 324px;margin-top: 8px;"
                :disabled="isActiveEditCampaign()"
                :placeholder="$t('seller.common.selectDate')"
                :disabled-date="disablePastDates" 

                />
              <p v-if="step1Errors.startDate" class="field-error-text">{{ step1Errors.startDate }}</p>
            </div>
            <div class="field" :class="{ 'field-error': !!step1Errors.endDate }">
              <label>{{ $t('seller.cpcIndex.colEndDate') }}<span class="label-required">*</span></label>
              <a-date-picker v-model:value="form.endDate" style="width: 324px;margin-top: 8px;"
                :placeholder="$t('seller.common.selectDate')"
                :disabled-date="disableEndDate" />
              <p v-if="step1Errors.endDate" class="field-error-text">{{ step1Errors.endDate }}</p>
            </div>
          </div>

          <div class="field" :class="{ 'field-error': !!step1Errors.linkType }">
            <label>
              {{ $t('seller.cpcCreate.labelLinkTypeCpc') }}<span class="label-required">*</span>
              <span class="small">{{ $t('seller.cpcCreate.hintLinkTypeCpc') }}</span>
            </label>
            <p v-if="step1Errors.linkType" class="field-error-text">{{ step1Errors.linkType }}</p>
            <div class="cpc-line" :class="{ 'field-error': !!step1Errors.attributionCpcUnitPrice }">
              <div class="item">
                <img src="../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                <span class="item-text">Attribution</span>
              </div>
              <a-input-number v-model:value="form.attributionCpcUnitPrice" style="width: 220px" :min="0.1" :step="0.1"
                :precision="1" :controls="false" @blur="validateCpcField('attributionCpcUnitPrice')"
                :disabled="!form.attributionCpcEnabled">
                <template #prefix>
                {{ currency }}
              </template>
            </a-input-number>
              <a-segmented v-model:value="form.attributionCpcEnabled" class="cpc-link-segmented"
                :class="{ 'is-off': !form.attributionCpcEnabled }" :options="cpcOffOnSegmentOptions"
                @change="onLinkTypeToggle('attribution', $event)"
                style="background-color: rgba(234, 232, 240, 1);" />
              
              <!-- <a-switch
              v-model:checked="form.attributionCpcEnabled"
             @change="onLinkTypeToggle('attribution', $event)"
            /> -->
            </div>
            <div class="field-error-text">
                {{ $t('seller.cpcCreate.hintAttributionCommissionPayable') }}
            </div>
            <p v-if="step1Errors.attributionCpcUnitPrice" class="field-error-text">{{
              step1Errors.attributionCpcUnitPrice }}</p>
            <div class="cpc-line" :class="{ 'field-error': !!step1Errors.associateCpcUnitPrice }">
              <div class="item">
                <img src="../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                <span class="item-text">Associate
                </span>

              </div>
              <a-input-number v-model:value="form.associateCpcUnitPrice" style="width: 220px" :min="0.1" :step="0.1"
                :precision="1" :controls="false" @blur="validateCpcField('associateCpcUnitPrice')"
                :disabled="!form.associateCpcEnabled" >
                <template #prefix>
                {{ currency }}
              </template>
            </a-input-number>
              <a-segmented v-model:value="form.associateCpcEnabled" class="cpc-link-segmented"
                :class="{ 'is-off': !form.associateCpcEnabled }" :options="cpcOffOnSegmentOptions"
                @change="onLinkTypeToggle('associate', $event)" style="background-color: rgba(234, 232, 240, 1);" />
              <!-- <a-switch
              v-model:checked="form.associateCpcEnabled"
              @change="onLinkTypeToggle('associate', $event)"
            /> -->
            </div>
            <p v-if="step1Errors.associateCpcUnitPrice" class="field-error-text">{{ step1Errors.associateCpcUnitPrice }}
            </p>
          </div>
          <div class="cpc-platform-fee-box">
            <div class="cpc-platform-fee-title">{{ $t('seller.cpcCreate.cpcPlatformFeeTitle') }}</div>
            <div class="cpc-platform-fee-desc">{{ $t('seller.cpcCreate.cpcPlatformFeeDesc') }}</div>
          </div>
          <div style="padding-top: 5px;" v-if="!form.attributionCpcEnabled && form.associateCpcEnabled">
            {{ !form.attributionCpcEnabled && form.associateCpcEnabled ? $t('seller.cpcCreate.associateOnlyAsinNote') : '' }}
          </div> 
          <!-- <p class="platform-fee-note">
            <span>
              <svg class="icon" aria-hidden="true" style="width: 16px;height: 16px;">
                <use xlink:href="#icon-a-warring-tianchong3"></use>
              </svg>
            </span>
            <div>
           <div>{{ $t('seller.cpcCreate.platformFeeLine') }}</div>
          
          
          </div>
          </p> -->
        </div>
      </div>

      <div v-show="currentStep === 1" class="step-asins">
        <div class="form-title">
          {{ $t('seller.cpcCreate.formTitleAsins') }}
        </div>
        <div class="field" style="margin-bottom: 0px;">
          <label>{{ $t('seller.cpcCreate.labelAsinDraft') }}</label>
          <div class="asin-input-row" ref="asinSearchInputRowRef">
            <div
              ref="asinDraftSelectWrapRef"
              class="asin-tag-select-wrap"
              @paste.capture="onAsinDraftPaste"
            >
              <artmisads-select
                v-model:value="asinDraftTags"
                mode="tags"
                :options="asinSearchOptions"
                :search-value="asinSearchValue"
                :token-separators="[',', ';', '\n', '\t']"
                :filter-option="false"
                :not-found-content="null"
                show-search
                :show-arrow="false"
                size="middle"
                style="width: 100%"
                :placeholder="$t('seller.cpcCreate.placeholderAsinSearch')"
                class="asin-tags-select"
                :getPopupContainer="getAsinDraftSelectPopupContainer"
                @search="onAsinSearch"
                @select="onAsinSelect"
                @deselect="onAsinDraftDeselect"
                @blur="onAsinDraftBlur"
              />
              <a-spin v-if="searchLoading" class="asin-search-spin" size="small" />
              <div
                v-if="searchResults.length && showAsinSearchHitList"
                ref="asinSearchHitsRef"
                class="asin-search-hits"
              >
                <div
                  v-for="row in searchResults"
                  :key="row.id"
                  class="asin-hit-row"
                  :class="{ 'is-in-draft': isAsinInDraftTags(row) }"
                  @click="addProductFromSearch(row)"
                >
                  <span class="asin-hit-text" >
                    {{ row.asin }}
                    <span v-if="String(row.amazonName || row.amazonSellerName || row.brandName || '').trim()"
                      class="asin-hit-seller">
                      ({{ row.amazonName || row.amazonSellerName || row.brandName }})
                    </span>
                  </span>
                  <!-- <a v-if="!isAsinInSelectedTable(row?.asin)" class="asin-hit-add" href="javascript:void(0)"
                    @click="addProductFromSearch(row)">
                    Add
                  </a> -->
                  <!-- <span v-else class="asin-hit-added">Added</span> -->
                </div>
              </div>
            </div>
            <a-button
              type="primary"
              :disabled="selectedProducts.length >= MAX_ASINS || !asinDraftTags.length"
              class="btn-add-list"
              @click="addDraftTagsToSelected"
            >
              
              <img v-if="selectedProducts.length >= MAX_ASINS || !asinDraftTags.length" src="../../../assets/images/img/btniconDis.png" alt="" class="add-icon">
              <img v-else src="../../../assets/images/img/btnicon.png" alt="" class="add-icon">
              {{ $t('seller.cpcCreate.btnAddToSelectedList') }}
            </a-button>
          </div>
          <p class="asin-paste-hint">
            {{ $t('seller.cpcCreate.asinPasteHint') }}
          </p>
        </div>
        <div class="form-title">
          {{ $t('seller.cpcCreate.formTitleSelectedAsins') }}
        </div>
        <!-- <h3 class="selected-asins-title">Selected ASINs</h3> -->
        <artmisads-table :columns="asinTableColumns" :data-source="selectedProducts" :pagination="false" row-key="asin"
          class="asin-table">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'deal'">
              <div class="deal-cell">
                <product-deals-column v-if="record.productDeals?.length" v-for="item in record.productDeals"
                  :record="item" :key="item.id" />
               
                <span v-if="!record.productDeals?.length" class="deal-empty">-</span>
              </div>
            </template>
            <template v-else-if="column.key === 'amazonName'">
              {{ record.amazonName||record.amazonSellerName }}
            </template>
            <template v-else-if="column.key === 'price'">
              <Price :record="record"/>
            </template>
            <template v-else-if="column.key === 'action'">
              <div v-if="isLockedCampaignProduct(record)" class="link-remove is-locked">{{ $t('seller.cpcCreate.locked') }}</div>
              <div v-else href="javascript:void(0)" class="link-remove" @click="removeSelectedProduct(record)">
                {{ $t('seller.cpcCreate.remove') }}
              </div>
            </template>
          </template>
        </artmisads-table>
      </div>

      <div v-show="currentStep === 2" class="step-publishers">
        <div class="form-title">
          {{ $t('seller.cpcCreate.formTitlePublishers') }}
        </div>
        <div class="publisher-toolbar">
          <ButtonGroups :pagination="publisherPagination" :table-data="publisherRows"
            @pageChange="onPublisherPageChange" />
          <a-input-search v-model:value="publisherSearchKeyword" :placeholder="$t('seller.cpcCreate.placeholderPublisherSearch')" allow-clear
            class="publisher-search" @search="onPublisherSearch" @pressEnter="onPublisherSearch" />
        </div>
        <div class="publisher-filters">
          <div class="publisher-filter-item">
            <div class="publisher-filter-label">{{ $t('seller.cpcCreate.filterPartneredInCpc') }}</div>
            <artemisads-segmented v-model:value="publisherFilterPartnered" class="publisher-segmented"
              :options="publisherPartneredSegmentOptions" @change="onPublisherFilterChange" />
          </div>
          <div class="publisher-filter-item">
            <div class="publisher-filter-label">{{ $t('seller.cpcCreate.filterPromotionMethod') }}</div>
            <a-select showSearch v-model:value="publisherFilterMethodId" style="width: 220px" :options="promotionMethodsList"
              :allow-clear="false" @change="onPublisherFilterChange" />
          </div>
          <div class="publisher-filter-item">
            <div class="publisher-filter-label">{{ $t('seller.cpcCreate.filterPromotionCategories') }}</div>
            <a-select showSearch v-model:value="publisherFilterCategoryId" style="width: 220px"
              :options="promotionProductCategoryList" :filter-option="filterCategoryListOption" :allow-clear="false"
              @change="onPublisherFilterChange" />
          </div>
           <div class="publisher-filter-item" ref="sortRef">
            <div class="publisher-filter-label">{{ $t('seller.cpcCreate.sortBy') }}</div>
            <artmisads-select
          v-model:value="priceSort"
          style="width: 180px"
          @change="onPublisherSortChange"
          :getPopupContainer="() => $refs.sortRef"
        >
          <a-select-option value="recommendedAsc">
            <Icon name="paixu1" class="iconAsc paixuIcon"/>
             <span class="paixuText">{{ $t('seller.cpcCreate.sortOptionRecommended') }}</span>  
          </a-select-option>
          <a-select-option value="recommendedDesc">
            <Icon name="paixu1" class="paixuIcon"/>
             <span class="paixuText">{{ $t('seller.cpcCreate.sortOptionRecommended') }}</span>  
          </a-select-option>
          <a-select-option value="nameAsc" class="paixuIcon">
            <Icon name="paixu1" class="iconAsc paixuIcon"/>
             <span class="paixuText">{{ $t('seller.cpcCreate.sortOptionName') }}</span> 
          </a-select-option>
          <a-select-option value="nameDesc" class="paixuIcon">
            <Icon name="paixu1" class="paixuIcon"/>
             <span class="paixuText">{{ $t('seller.cpcCreate.sortOptionName') }}</span> 
          </a-select-option>
          <a-select-option value="campaignsJoinedAsc" class="paixuIcon">
            <Icon name="paixu1" class="iconAsc paixuIcon"/>
             <span class="paixuText">{{ $t('seller.cpcCreate.sortOptionCampaignsJoined') }}</span> 
          </a-select-option>
          <a-select-option value="campaignsJoinedDesc" class="paixuIcon">
            <Icon name="paixu1" class="paixuIcon"/>
             <span class="paixuText">{{ $t('seller.cpcCreate.sortOptionCampaignsJoined') }}</span> 
          </a-select-option>
        </artmisads-select>
           </div>
        </div>
        <artmisads-table v-model:pagination="publisherPagination" :row-selection="publisherRowSelection"
          :row-key="(record) => normalizePublisherId(getPublisherRowId(record))" :columns="publisherColumns"
          :data-source="publisherRows" :change="onPublisherTableChange" :loading="publisherListLoading"
          :scroll="{ x: 1180 }" class="publisher-table">
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'publisher'">
              <div class="publisher-cell">
                <LogoImage :max-width="'95%'" :logo-url="record.publisherAvatarUrl" :brand-name="record.creatorName"
                  :width="40" :height="40" :font-size="10" :border-radius="4" />
                <span class="publisher-name">{{ record.creatorName }}</span>
              </div>
            </template>
            <template v-else-if="column.key === 'maxBudgetCap'">
              <div class="budget-cap-cell">
                <template v-if="isBudgetEditing(getPublisherRowId(record), 'publisherTotalCap')">
                  <a-input
                    :value="budgetEditingValue"
                    size="small"
                    class="budget-input"
                    :class="{ 'budget-input-error': !!getPublisherBudgetError(getPublisherRowId(record), 'publisherTotalCap') }"
                    @update:value="budgetEditingValue = $event"
                    @pressEnter="saveBudgetEdit(getPublisherRowId(record), 'publisherTotalCap')"
                  >
                    <template #prefix>{{ currency }}</template>
                  </a-input>
                  <div class="budget-edit-actions">
                    <a-button size="small" class="budget-edit-btn cancel" @click="cancelBudgetEdit">
                      <CloseOutlined />
                    </a-button>
                    <a-button
                      size="small"
                      type="primary"
                      class="budget-edit-btn save"
                      @click="saveBudgetEdit(getPublisherRowId(record), 'publisherTotalCap')"
                    >
                      <CheckOutlined />
                    </a-button>
                  </div>
                </template>
                <template v-else>
                  <span class="budget-display-value">
                    {{ getPublisherBudgetDisplay(getPublisherRowId(record), 'publisherTotalCap') }}
                  </span>
                  <span class="line-separator">
                    |
                  </span>
                  
                  <a class="budget-edit-trigger" href="javascript:void(0)" @click="startBudgetEdit(getPublisherRowId(record), 'publisherTotalCap')">
                    <EditOutlined class="edit-budget-icon" />
                  </a>
                </template>
                <p v-if="getPublisherBudgetError(getPublisherRowId(record), 'publisherTotalCap')"
                  class="budget-error-text">
                  {{ getPublisherBudgetError(getPublisherRowId(record), 'publisherTotalCap') }}
                </p>
              </div>
            </template>
            <template v-else-if="column.key === 'dailyBudgetCap'">
              <div class="budget-cap-cell">
                <template v-if="isBudgetEditing(getPublisherRowId(record), 'publisherDailyCap')">
                  <a-input
                    :value="budgetEditingValue"
                    size="small"
                    class="budget-input"
                    :class="{ 'budget-input-error': !!getPublisherBudgetError(getPublisherRowId(record), 'publisherDailyCap') }"
                    @update:value="budgetEditingValue = $event"
                    @pressEnter="saveBudgetEdit(getPublisherRowId(record), 'publisherDailyCap')"
                  >
                    <template #prefix>{{ currency }}</template>
                  </a-input>
                  <div class="budget-edit-actions">
                    <a-button size="small" class="budget-edit-btn cancel" @click="cancelBudgetEdit">
                      <CloseOutlined />
                    </a-button>
                    
                    <a-button
                      size="small"
                      type="primary"
                      class="budget-edit-btn save"
                      @click="saveBudgetEdit(getPublisherRowId(record), 'publisherDailyCap')"
                    >
                      <CheckOutlined />
                    </a-button>
                  </div>
                </template>
                <template v-else>
                  <span class="budget-display-value">
                    {{ getPublisherBudgetDisplay(getPublisherRowId(record), 'publisherDailyCap') }}
                  </span>
                  <span class="line-separator">
                    |
                  </span>
                  <a class="budget-edit-trigger" href="javascript:void(0)" @click="startBudgetEdit(getPublisherRowId(record), 'publisherDailyCap')">
                    <EditOutlined class="edit-budget-icon" />
                  </a>
                </template>
                <p v-if="getPublisherBudgetError(getPublisherRowId(record), 'publisherDailyCap')"
                  class="budget-error-text">
                  {{ getPublisherBudgetError(getPublisherRowId(record), 'publisherDailyCap') }}
                </p>
              </div>
            </template>
            <template v-else-if="column.key === 'cpcPartnered'">
              {{ record.cpcPartnered }}
            </template>
            <template v-else-if="column.key === 'promotionMethods'">
              {{ joinPromotionNames(record.promotionMethods, 1) }}
            </template>
            <template v-else-if="column.key === 'promotionProductCategories'">
              <a-tooltip placement="top" :mouse-enter-delay="0.5">
                <template #title>
                  <span>{{ joinPromotionNames(record.promotionCategories) }}</span>
                </template>
                <div class="text-ellipsis-2">
                  {{ joinPromotionNames(record.promotionCategories, 3) }}
                </div>
              </a-tooltip>
            </template>
            <template v-else-if="column.key === 'atcRateLast30d'">
              {{ record.atcRateLast30d ? (record.atcRateLast30d * 100).toFixed(2) + '%' : '--' }}
            </template>
          </template>
        </artmisads-table>
      </div>

    </div>

    <div class="actions">
      <template v-if="currentStep === 0">
        <div class="actions-one">
          <artmisads-button type="default" @click="goCpc">{{ $t('seller.cpcCreate.btnCancel') }}</artmisads-button>
          <artmisads-button type="primary" @click="nextStep">{{ $t('seller.cpcCreate.btnSaveNext') }}</artmisads-button>
        </div>

      </template>
      <template v-else-if="currentStep === 1">
        <div class="actions-one">
          <artmisads-button type="default" @click="prevStep">{{ $t('seller.cpcCreate.btnBack') }}</artmisads-button>
          <artmisads-button type="primary" @click="nextFromAsinStep" :disabled="selectedProducts.length === 0">{{ $t('seller.cpcCreate.btnSaveNext') }}
          </artmisads-button>
        </div>
      </template>
      <template v-else>
        <div class="actions-two">
          <div class="publisher-summary-bar">
            <div class="publisher-summary-item">
              <span class="publisher-summary-label">{{ $t('seller.cpcCreate.selectedPublishersLabel') }}</span>
              <span class="publisher-summary-value">{{ selectedPublisherCount }}</span>
            </div>
            <div class="publisher-summary-item">
              <span class="publisher-summary-label">{{ $t('seller.cpcCreate.estimatedDailyBudget') }}</span>
              <span class="publisher-summary-value">{{ currency }} {{ formatBudgetAmount(estimatedDailyBudget) }}</span>
            </div>
            <div class="publisher-summary-item">
              <span class="publisher-summary-label">{{ $t('seller.cpcCreate.estimatedMaxBudget') }}</span>
              <span class="publisher-summary-value">{{ currency }} {{ formatBudgetAmount(estimatedMaxBudget) }}</span>
            </div>
          </div>
          <div class="actions-right">
          <artmisads-button type="default" @click="prevStep">{{ $t('seller.cpcCreate.btnBack') }}</artmisads-button>
          <artmisads-button type="primary" @click="submitCampaign" :disabled="selectedPublisherCount === 0">{{ $t('seller.cpcCreate.btnSubmit') }}</artmisads-button>
          </div>
        </div>
        
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, h, nextTick, onMounted, onUnmounted, reactive, ref, watch } from "vue"
import { useI18n } from "vue-i18n"
import { useRoute, useRouter } from "vue-router"
import { message, Tooltip } from "ant-design-vue"
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons-vue"
import { productsApi, publishersApi, sellerCpcApi } from "@/server/index"
import moment from "moment"
import ProductDealsColumn from "~/components/productDealsColumn.vue"
import Price from "~/components/Price.vue"
import ButtonGroups from "@/pages/seller/Brands/components/buttonGroups.vue"
import LogoImage from "@/components/LogoImage.vue"
import { CURRENCY_MAPPER, CURRENCY_DATA_MAPPER } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"
import noticeTool from './components/noticeTool.vue'
import ProductDealsCopy from '@/components/productDealsCopy.vue'
import breadcrumbs from "~/pages/seller/breadcrumbs.vue"
import Icon from "@/components/Icon.vue";
const { t } = useI18n()
const user = useUserInfoStore()
const currency = CURRENCY_MAPPER[user.userInfo?.countryCode]?.currency || '$'
const countryCode = user?.userInfo?.countryCode || 'US'
const router = useRouter()
const route = useRoute()
const currentStep = ref(0)
const priceSort=ref('recommendedDesc')
/** 顶部步骤条：始终显示步骤序号，不使用完成态默认勾选图标 */
const CPC_CREATE_STEP_TITLE_KEYS = [
  "seller.cpcCreate.stepSetupInfo",
  "seller.cpcCreate.stepSelectAsins",
  "seller.cpcCreate.stepSelectPublishers",
]

const pageMode = computed(() => {
  const mode = String(route.query.mode || "").toLowerCase()
  if (mode === "edit" || mode === "view") return mode
  return "create"
})

const breadcrumbsData = computed(() => ({
  title:
    pageMode.value === "edit"
      ? t("seller.cpcCreate.breadcrumbEdit")
      : pageMode.value === "view"
        ? t("seller.cpcCreate.breadcrumbView")
        : t("seller.cpcCreate.breadcrumbCreate"),
  color: "#26AADC",
  hasTitleIcon: false,
  links: [
    { name: t("seller.common.home"), path: "/seller/dashboard" },
    { name: t("seller.cpcIndex.breadcrumbCpc"), path: "/seller/cpc" },
  ],
}))

const editCampaignId = computed(() => {
  const raw = route.query.campaignId
  if (raw === undefined || raw === null || raw === "") return null
  const id = Number(raw)
  return Number.isFinite(id) ? id : null
})

/** 编辑详情里的活动级预算快照；保存 Step1 时若输入低于该值则改回快照值 */
const editLoadedTotalBudget = ref(null)
const editLoadedPublisherTotalCap = ref(null)
const editLoadedPublisherDailyCap = ref(null)

const publisherPagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  size: 10,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "30", "40", "50"],
})
const publisherRows = ref([])
const publisherListLoading = ref(false)
const publisherSearchKeyword = ref("")
const publisherFilterPartnered = ref("ALL")
const publisherFilterMethodId = ref("")
const publisherFilterCategoryId = ref("")
const promotionMethodsData = ref([])
const promotionCategoriesData = ref([])
const promotionMethodsList = computed(() => [
  { value: "", label: t("seller.common.all") },
  ...promotionMethodsData.value,
])
const promotionProductCategoryList = computed(() => [
  { value: "", label: t("seller.common.all") },
  ...promotionCategoriesData.value,
])
const allSelectedPublisherIds = ref(new Set())
const publisherSelectedRowKeys = ref([])
const publisherBudgetById = reactive({})
const publisherBudgetErrorsById = reactive({})
const originalPublisherBudgetById = reactive({})
const normalizePublisherId = (id) => String(id ?? "").trim()

const cpcOffOnSegmentOptions = computed(() => [
  { label: t("seller.cpcCreate.off"), value: false },
  { label: t("seller.cpcCreate.on"), value: true },
])

const publisherPartneredSegmentOptions = computed(() => [
  { label: t("seller.cpcCreate.segmentAll"), value: "ALL" },
  { label: t("seller.cpcCreate.segmentPartnered"), value: "Partnered" },
  { label: t("seller.cpcCreate.segmentNotPartnered"), value: "Not Partnered" },
])

const publisherColumns = computed(() => [
  { title: t("seller.cpcCreate.colPublisher"), key: "publisher", dataIndex: "publisher", width: 220 },
  { title: t("seller.cpcCreate.colMaxBudgetCap"), key: "maxBudgetCap", width: 160 },
  { title: t("seller.cpcCreate.colDailyBudgetCap"), key: "dailyBudgetCap", width: 160 },
  { title: t("seller.cpcCreate.colAtcRateLast30d"), key: "atcRateLast30d", dataIndex: "atcRateLast30d", width: 140 },
  // { title: t("seller.cpcCreate.colCpcPartnered"), key: "cpcPartnered", width: 140 },
  { title: t("seller.cpcCreate.colPromotionMethod"), key: "promotionMethods", dataIndex: "promotionMethods", width: 220 },
  {
    title: t("seller.cpcCreate.colPromotionCategories"),
    key: "promotionProductCategories",
    dataIndex: "promotionProductCategories",
    width: 260,
  },
])

const filterCategoryListOption = (input, option) =>
  String(option?.label ?? "")
    .toLowerCase()
    .includes(String(input ?? "").toLowerCase())

const joinPromotionNames = (list, limit) => {
  if (!list?.length) return "-"
  if (limit != null) {
    const shown = list.slice(0, limit).join(", ")
    return list.length > limit ? `${shown},...` : shown
  }
  return list.join(", ")
}

// const cpcPartneredLabel = (record) => {
//   if (record.associateBrandCount > 0) return "Partnered"
//   return "Not Partnered"
// }

const ensureBudgetRow = (id) => {
  if (id == null || id === "") return
  const key = String(id)
  if (!publisherBudgetById[key]) {
    publisherBudgetById[key] = {

      publisherTotalCap: "",
      publisherDailyCap: "",
    }
  }
}

const getPublisherRowId = (record) => record?.publisherId ?? record?.id

const getPublisherBudgetValue = (id, key) => {
  if (id == null || id === "") return ""
  return publisherBudgetById[String(id)]?.[key] ?? ""
}

const ensurePublisherBudgetErrorRow = (id) => {
  if (id == null || id === "") return
  const key = String(id)
  if (!publisherBudgetErrorsById[key]) {
    publisherBudgetErrorsById[key] = {
      publisherTotalCap: "",
      publisherDailyCap: "",
    }
  }
}

const getPublisherBudgetError = (id, key) =>
  publisherBudgetErrorsById[String(id)]?.[key] ?? ""

const setPublisherBudgetError = (id, key, msg) => {
  ensurePublisherBudgetErrorRow(id)
  const rowKey = String(id)
  if (!publisherBudgetErrorsById[rowKey]) return
  publisherBudgetErrorsById[rowKey][key] = msg
}

const clearPublisherBudgetErrors = () => {
  for (const id of Object.keys(publisherBudgetErrorsById)) {
    delete publisherBudgetErrorsById[id]
  }
}

const clearOriginalPublisherBudgets = () => {
  for (const id of Object.keys(originalPublisherBudgetById)) {
    delete originalPublisherBudgetById[id]
  }
}

const setPublisherBudgetValue = (id, key, value) => {
  ensureBudgetRow(id)
  const rowKey = String(id)
  if (!publisherBudgetById[rowKey]) return
  publisherBudgetById[rowKey][key] = value
  setPublisherBudgetError(id, key, "")
}

const budgetEditingRowId = ref("")
const budgetEditingKey = ref("")
const budgetEditingValue = ref("")
const lockedInitialLinkTypes = reactive({
  attribution: false,
  associate: false,
})

const isBudgetEditing = (id, key) =>
  String(budgetEditingRowId.value) === String(id) && budgetEditingKey.value === key

const getPublisherBudgetDisplay = (id, key) => {
  const value = String(getPublisherBudgetValue(id, key) ?? "").trim()
  if (!value) return `${currency} ${key === "publisherTotalCap" ? form.publisherTotalCap : form.publisherDailyCap}`
  return `${currency} ${value}`
}

const startBudgetEdit = (id, key) => {
  ensureBudgetRow(id)
  budgetEditingRowId.value = String(id)
  budgetEditingKey.value = key
  let initial = String(getPublisherBudgetValue(id, key) ?? "").trim()
  if (!initial) {
    initial = String(
      key === "publisherTotalCap"
        ? (form.publisherTotalCap ?? "")
        : (form.publisherDailyCap ?? ""),
    ).trim()
  }
  budgetEditingValue.value = initial
}

const cancelBudgetEdit = () => {
  budgetEditingRowId.value = ""
  budgetEditingKey.value = ""
  budgetEditingValue.value = ""
}

const saveBudgetEdit = (id, key) => {
  if (pageMode.value === "edit" && editCampaignId.value) {
    const defaultValue =
      key === "publisherTotalCap"
        ? toOptionalNumber(form.publisherTotalCap)
        : toOptionalNumber(form.publisherDailyCap)

    let nextValue = toOptionalNumber(budgetEditingValue.value)
    if (nextValue === undefined && defaultValue !== undefined) {
      // Treat empty as default in edit mode to match submit validation.
      nextValue = defaultValue
      budgetEditingValue.value = String(defaultValue)
    }

    const originalValue = toOptionalNumber(originalPublisherBudgetById[String(id)]?.[key])
    if (nextValue !== undefined && originalValue !== undefined && nextValue < originalValue) {
      const msg = t("seller.cpcCreate.msgCannotLowerThanCurrent")
      setPublisherBudgetError(id, key, msg)
      message.warning(msg)
      return
    }

    if (nextValue !== undefined && defaultValue !== undefined && nextValue < defaultValue) {
      const msg = t("seller.cpcCreate.msgCannotLowerThanValue", { value: defaultValue })
      setPublisherBudgetError(id, key, msg)
      message.warning(msg)
      return
    }
  }
  
  setPublisherBudgetValue(id, key, budgetEditingValue.value)
  cancelBudgetEdit()
}

const initBudgetForRows = (rows) => {
  for (const r of rows || []) {
    ensureBudgetRow(getPublisherRowId(r))
  }
}

const syncPublisherSelectionAfterLoad = () => {
  const pageIds = new Set(
    publisherRows.value.map((r) => normalizePublisherId(r.publisherId)),
  )
  publisherSelectedRowKeys.value = [...allSelectedPublisherIds.value].filter((id) =>
    pageIds.has(normalizePublisherId(id)),
  )
}

const isActiveEditCampaign = () =>
  pageMode.value === "edit" &&
  String(form.status ?? "").trim().toUpperCase() === "ACTIVE"

/** Matches table/API values like "Not Partnered" or NOT_PARTNERED */
const isPublisherCpcNotPartnered = (recordOrInvite) => {
  const raw = String(recordOrInvite?.cpcPartnered ?? "").trim().toLowerCase().replace(/_/g, " ")
  return raw === "not partnered"
}

/** publisherInvites[].joined：true 不可勾选，false/缺失 可勾选（与 getCheckboxProps 一致） */
const isPublisherInviteJoinedFlag = (invite) => {
  if (!invite) return false
  const j = invite.joined
  if (typeof j === "boolean") return j
  if (typeof j === "number") return j === 1
  if (typeof j === "string") {
    const s = j.trim().toLowerCase()
    return s === "true" || s === "1"
  }
  return false
}

const getPublisherInviteByPublisherId = (publisherId) => {
  const nid = normalizePublisherId(publisherId)
  if (!nid) return undefined
  return (form.publisherInvites || []).find(
    (x) => normalizePublisherId(x?.publisherId) === nid,
  )
}

const getJoinedPublisherIdsForSelectionMerge = () => {
  const ids = []
  for (const inv of form.publisherInvites || []) {
    if (!isPublisherInviteJoinedFlag(inv)) continue
    const id = normalizePublisherId(inv.publisherId)
    if (id) ids.push(id)
  }
  return ids
}

function onPublisherSelectChange (keys) {
  const normalizedKeys = (keys || []).map((id) => normalizePublisherId(id))
  const mergedKeys = [
    ...new Set([...normalizedKeys, ...getJoinedPublisherIdsForSelectionMerge()]),
  ]
  publisherSelectedRowKeys.value = mergedKeys
  const pageIds = publisherRows.value.map((r) => normalizePublisherId(r.publisherId))
  const next = new Set(allSelectedPublisherIds.value)
  for (const id of pageIds) {
    if (mergedKeys.includes(id)) {
      next.add(id)
      ensureBudgetRow(id)
    } else {
      next.delete(id)
    }
  }
  allSelectedPublisherIds.value = next
}

const isPublisherRowSelectionDisabledByJoined = (record) => {
  const inv = getPublisherInviteByPublisherId(record?.publisherId)
  return isPublisherInviteJoinedFlag(inv)
}

const publisherRowSelection = computed(() => {
  void form.publisherInvites
  return {
  selectedRowKeys: publisherSelectedRowKeys.value,
  preserveSelectedRowKeys: true,
  onChange: onPublisherSelectChange,
  getCheckboxProps: (record) => ({
    disabled: isPublisherRowSelectionDisabledByJoined(record),
  }),
  renderCell: (checked, record, _index, originNode) => {
    if (!isPublisherRowSelectionDisabledByJoined(record)) return originNode
    return h(
      Tooltip,
      {
        title: t("seller.cpcCreate.publisherJoinedCampaign"),
        placement: "top",
        getPopupContainer: () => document.body,
      },
      {
        default: () =>
          h("span", { class: "cpc-publisher-locked-select-tooltip-wrap" }, [originNode]),
      },
    )
  },
  }
})

const selectedPublisherCount = computed(() => allSelectedPublisherIds.value.size)

const loadPromotionMethods = async () => {
  const res = await publishersApi.getPromotionMethodsList()
  if (res?.success && res.data) {
    promotionMethodsData.value = res.data.map((item) => ({ value: item.id, label: item.name }))
  } else if (res?.error) {
    message.error(res.error)
  }
}

const loadPromotionCategories = async () => {
  const res = await publishersApi.getPromotionProductCategoryList()
  if (res?.success && res.data) {
    promotionCategoriesData.value = res.data.map((item) => ({ value: item.id, label: item.name }))
  } else if (res?.error) {
    message.error(res.error)
  }
}
const sortField=ref('createdAt')
const sortDirection=ref('desc')
const onPublisherSortChange = (value) => {
  publisherPagination.current=1
  if(value === 'recommendedAsc'){
    sortField.value = 'createdAt'
    sortDirection.value = 'asc'
  }else if(value === 'recommendedDesc'){
    sortField.value = 'createdAt'
    sortDirection.value = 'desc'
  }else if(value === 'nameAsc'){
    sortField.value = 'creatorName'
    sortDirection.value = 'asc'
  }else if(value === 'nameDesc'){
    sortField.value = 'creatorName'
    sortDirection.value = 'desc'
  }else if(value === 'campaignsJoinedAsc'){
    sortField.value = 'campaignsJoinedCount'
    sortDirection.value = 'asc'
  }else if(value === 'campaignsJoinedDesc'){
    sortField.value = 'campaignsJoinedCount'
    sortDirection.value = 'desc'
  }
  loadPublisherList()
}
const loadPublisherList = async () => {
  publisherListLoading.value = true
  try {
    const cpcPartnered =
      publisherFilterPartnered.value === "Partnered"
        ? "PARTNERED"
        : publisherFilterPartnered.value === "Not Partnered"
          ? "NOT_PARTNERED"
          : undefined
    const res = await sellerCpcApi.getCpcCampaignsPublisherPreview({
      page: publisherPagination.current,
      size: publisherPagination.pageSize,
      keyword: publisherSearchKeyword.value,
      cpcPartnered: cpcPartnered,
      promotionMethodIds: publisherFilterMethodId.value ? publisherFilterMethodId.value : undefined,
      promotionCategoryIds: publisherFilterCategoryId.value ? publisherFilterCategoryId.value : undefined,
      sortField:sortField.value,
      sortDirection:sortDirection.value,
    })
    if (res?.success) {
      publisherRows.value =
        res.data?.data || []

      publisherPagination.total = res.data?.total ?? 0
      publisherPagination.size = publisherPagination.pageSize
      initBudgetForRows(publisherRows.value)
      syncPublisherSelectionAfterLoad()
    } else {
      message.error(res?.error || t("seller.cpcCreate.msgFailedLoadPublishers"))
    }
  } catch {
    message.error(t("seller.cpcCreate.msgFailedLoadPublishers"))
  } finally {
    publisherListLoading.value = false
  }
}

const onPublisherPageChange = (currPage) => {
  publisherPagination.current = currPage
  loadPublisherList()
}

const onPublisherTableChange = ({ current, pageSize }) => {
  publisherPagination.current = current
  publisherPagination.pageSize = pageSize
  publisherPagination.size = pageSize
  loadPublisherList()
}

const onPublisherSearch = () => {
  publisherPagination.current = 1
  loadPublisherList()
}

const onPublisherFilterChange = () => {
  publisherPagination.current = 1
  loadPublisherList()
}

let publisherListsLoaded = false
const ensurePublisherStepData = async () => {
  if (!publisherListsLoaded) {
    publisherListsLoaded = true
    await Promise.all([loadPromotionMethods(), loadPromotionCategories()])
  }
  await loadPublisherList()
}

watch(currentStep, (step) => {
  if (step === 2) {
    ensurePublisherStepData()
  }
})

const MAX_ASINS = 20
const asinDraftTags = ref([])
// Track tags that come from search rows by row.id
const draftSearchRowIds = ref(new Set())
const draftTagLabelToRowId = ref({})
const asinSearchValue = ref("")
const selectedProducts = ref([])
const lockedExistingProductIds = ref(new Set())
const searchResults = ref([])
const searchLoading = ref(false)
/** 从 Excel 等粘贴批量 ASIN 时不展示下方预览列表，仅搜索输入时展示 */
const showAsinSearchHitList = ref(true)
const asinSearchInputRowRef = ref(null)
const asinDraftSelectWrapRef = ref(null)
const asinSearchHitsRef = ref(null)
const getAsinDraftSelectPopupContainer = () =>
  asinDraftSelectWrapRef.value || document.body
let asinSearchTimer = null
let asinSearchRequestId = 0

/** 不在下拉中挂选项，避免 mode=tags 选中即写入 asinDraftTags；仅下方命中行 + addProductFromSearch 写入草稿 */
const asinSearchOptions = computed(() => [])

const asinTableColumns = computed(() => [
  { title: t("seller.cpcCreate.colAsin"), dataIndex: "asin", key: "asin", width: 140 },
  { title: t("seller.cpcCreate.colBrand"), dataIndex: "brandName", key: "brandName", width: 140 },
  { title: t("seller.cpcCreate.colAmazonSellerName"), dataIndex: "amazonName", key: "amazonName", width: 200 },
  { title: t("seller.cpcCreate.colDeal"), key: "deal", width: 220 },
  { title: t("seller.cpcCreate.colPrice"), key: "price", width: 120 },
  { title: t("seller.cpcCreate.colAction"), key: "action", width: 100, fixed: "right" },
])

const normalizeAsin = (s) => String(s || "").trim().toUpperCase()
const normalizeDraftTagLabel = (s) => String(s ?? "").trim().toUpperCase()

/** 草稿 tag 可能是纯 ASIN 或 "ASIN (Seller)"，统一取出前 10 位 ASIN */
const extractAsinFromDraftTag = (tag) => {
  if (tag == null) return ""
  if (typeof tag === "object" && tag !== null) {
    const v = tag.value ?? tag.key ?? tag.label
    return extractAsinFromDraftTag(v)
  }
  const s = String(tag).trim().toUpperCase()
  const m = s.match(/^([A-Z0-9]{10})(?:$|[^A-Z0-9])/)
  return m ? m[1] : ""
}

const formatDraftTagLabel = (row) => {
  const asin = normalizeAsin(row?.asin)
  if (!isValidAsinTag(asin)) return asin
  const name = String(
    row?.amazonName ?? row?.amazonSellerName ?? row?.brandName ?? "",
  ).trim()
  return name ? `${asin} (${name})` : asin
}

const syncDraftTagRowTracking = () => {
  const keep = new Set(asinDraftTags.value.map((t) => normalizeDraftTagLabel(t)))
  for (const key of Object.keys(draftTagLabelToRowId.value)) {
    if (keep.has(key)) continue
    const rowId = String(draftTagLabelToRowId.value[key] ?? "")
    if (rowId) draftSearchRowIds.value.delete(rowId)
    delete draftTagLabelToRowId.value[key]
  }
}

/** 10 位字母数字，避免 mode=tags 失焦把搜索词误收成 tag */
const isValidAsinTag = (tag) => /^[A-Z0-9]{10}$/.test(normalizeAsin(tag))

/** 从剪贴板文本提取 ASIN（换行/逗号/空格等混排，如从 Excel 粘贴） */
const parseAsinsFromClipboardText = (text) => {
  const raw = String(text || "").toUpperCase()
  const matches = raw.match(/\b[A-Z0-9]{10}\b/g) || []
  const seen = new Set()
  const out = []
  for (const m of matches) {
    const a = normalizeAsin(m)
    if (!isValidAsinTag(a) || seen.has(a)) continue
    seen.add(a)
    out.push(a)
  }
  return out
}

const mergeParsedAsinsIntoDraft = (parsed) => {
  if (!parsed.length) return
  const seen = new Set(asinDraftTags.value.map((t) => extractAsinFromDraftTag(t)))
  const merged = [...asinDraftTags.value]
  for (const a of parsed) {
    if (merged.length >= MAX_ASINS) break
    if (seen.has(a)) continue
    seen.add(a)
    merged.push(a)
  }
  asinDraftTags.value = merged
}

// const isProductSelected = (row) => selectedProducts.value.some((p) => p.id === row.id)

const isAsinInSelectedTable = (asin) => {
  const a = normalizeAsin(asin)
  if (!a) return false
  return selectedProducts.value.some((p) => normalizeAsin(p?.asin) === a)
}

const isAsinInDraftTags = (row) => {
  const rowId = String(row?.id ?? "")
  if (!rowId) return false
  return draftSearchRowIds.value.has(rowId)
}

/** 接口 asins：多个 ASIN 用英文逗号拼接；否则用原始 trimmed 串（支持未输满的搜索词） */
const buildAsinsQueryParam = (keyword) => {
  const t = String(keyword || "").trim()
  if (!t) return ""
  const extracted = parseAsinsFromClipboardText(t)
  return extracted.length ? extracted.join(",") : t
}

const mergeSearchResultRows = (prev, next) => {
  const seen = new Set(
    (prev || []).map((r) => normalizeAsin(r?.asin)).filter((a) => a && isValidAsinTag(a)),
  )
  const out = [...(prev || [])]
  for (const row of next || []) {
    const a = normalizeAsin(row?.asin)
    if (!a || !isValidAsinTag(a)) continue
    if (seen.has(a)) continue
    seen.add(a)
    out.push(row)
  }
  return out
}

const fetchSearchResults = async (keyword, type) => {
  const requestId = ++asinSearchRequestId
  showAsinSearchHitList.value = type === "paste" ? false : true
  const q = buildAsinsQueryParam(keyword)
  if (!q) {
    searchResults.value = []
    if (type === "paste" && requestId === asinSearchRequestId) asinSearchValue.value = ""
    return
  }
  const keywordRaw = String(keyword ?? "").trim()
  const extractedTokens = parseAsinsFromClipboardText(keywordRaw)
  const batchPreview =
    extractedTokens.length >= 2 ||
    q.split(",").map((s) => s.trim()).filter(Boolean).length >= 2

  searchLoading.value = true
  try {
    const res = await sellerCpcApi.searchProducts({
      marketplace: CURRENCY_MAPPER[countryCode].host,
      asins:type=='paste' ? q : undefined,
      asin:type!='paste' ? keyword : undefined,
    })
    if (res?.success) {
      const list = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
          ? res.data
          : []
      const mergedRows = batchPreview
        ? list
        : list.length
          ? list
          : [...searchResults.value]
      searchResults.value = mergedRows
      
      if (mergedRows.length&&type=='paste') {
        const rowById = new Map()
        const rowsByAsin = new Map()
        for (const row of mergedRows) {
          const rowId = String(row?.id ?? "")
          const a = normalizeAsin(row?.asin)
          if (!rowId || !a || !isValidAsinTag(a)) continue
          rowById.set(rowId, row)
          if (!rowsByAsin.has(a)) rowsByAsin.set(a, [])
          rowsByAsin.get(a).push(row)
        }
        const seenRowIds = new Set()
        const merged = []
        for (const tag of asinDraftTags.value) {
          const a = extractAsinFromDraftTag(tag)
          if (!isValidAsinTag(a) || !rowsByAsin.has(a)) continue
          if (merged.length >= MAX_ASINS) break
          const candidates = rowsByAsin.get(a) || []
          let row = null
          for (const c of candidates) {
            const candidateId = String(c?.id ?? "")
            if (!candidateId || seenRowIds.has(candidateId)) continue
            row = c
            seenRowIds.add(candidateId)
            break
          }
          if (!row) continue
          merged.push(formatDraftTagLabel(row))
        }
        for (const row of list) {
          const rowId = String(row?.id ?? "")
          const a = normalizeAsin(row?.asin)
          if (!rowId || !a || !isValidAsinTag(a)) continue
          if (seenRowIds.has(rowId)) continue
          if (merged.length >= MAX_ASINS) break
          seenRowIds.add(rowId)
          merged.push(formatDraftTagLabel(row))
        }
        asinDraftTags.value = merged
        // Rebuild tag->rowId mapping for paste flow, so add-to-selected works by id.
        draftTagLabelToRowId.value = {}
        draftSearchRowIds.value.clear()
        for (const tag of merged) {
          const asin = extractAsinFromDraftTag(tag)
          const row = (rowsByAsin.get(asin) || []).find((r) =>
            normalizeDraftTagLabel(formatDraftTagLabel(r)) === normalizeDraftTagLabel(tag),
          )
          const rowId = String(row?.id ?? "")
          if (!rowId) continue
          const labelKey = normalizeDraftTagLabel(tag)
          draftTagLabelToRowId.value[labelKey] = rowId
          draftSearchRowIds.value.add(rowId)
        }
        syncDraftTagRowTracking()
      }
    } else {
      searchResults.value = []
    }
  } catch {
    searchResults.value = []
  } finally {
    searchLoading.value = false
    // Keep typed keyword while searching; only clear when paste flow ends.
    if (type === "paste" && requestId === asinSearchRequestId) asinSearchValue.value = ""
  }
}

const onAsinSearch = (val) => {
  
  asinSearchValue.value = val
  if (asinSearchTimer) clearTimeout(asinSearchTimer)
  const raw = String(val ?? "").trim()
  // 避免粘贴多 ASIN 后组件把搜索框清空，又 debounce 调 fetch("") 顶掉刚发起的预览请求
  if (!raw) return
  asinSearchTimer = setTimeout(() => fetchSearchResults(val,'search'), 320)
}

const onAsinSelect = () => {
  // Prevent raw search keyword from staying as a tag.
  // asinSearchValue.value = ""
}

const asinFromSelectValueArg = (val) => {
  if (val == null) return ""
  if (typeof val === "object" && val !== null) {
    const v = val.value ?? val.key ?? val.label
    return extractAsinFromDraftTag(v ?? "")
  }
  return extractAsinFromDraftTag(val)
}

/** 关闭 tag 时同步去掉下方预览列表中对应 ASIN */
const onAsinDraftDeselect = (val) => {
  const rawLabel =
    typeof val === "object" && val !== null
      ? (val.value ?? val.key ?? val.label)
      : val
  const labelKey = normalizeDraftTagLabel(rawLabel)
  const rowId = String(draftTagLabelToRowId.value[labelKey] ?? "")
  if (rowId) draftSearchRowIds.value.delete(rowId)
  delete draftTagLabelToRowId.value[labelKey]

  const a = asinFromSelectValueArg(val)
  if (!a) return
  searchResults.value = searchResults.value.filter(
    (r) => normalizeAsin(r?.asin) !== a,
  )
}

const formatAsinListForPasteHint = (asins, maxShow = 8) => {
  const u = [...new Set(asins.filter((a) => isValidAsinTag(normalizeAsin(a))))]
  if (!u.length) return ""
  if (u.length <= maxShow) return u.join(", ")
  return `${u.slice(0, maxShow).join(", ")} (+${u.length - maxShow})`
}

const onAsinDraftPaste = (e) => {
  const text = e.clipboardData?.getData?.("text/plain") ?? ""
  const parsed = parseAsinsFromClipboardText(text)
  const hasListShape = /[\r\n]/.test(text) || parsed.length >= 2
  if (!parsed.length || !hasListShape) return
  e.preventDefault()
  e.stopPropagation()
  const previewAsinSet = new Set(
    (searchResults.value || [])
      .map((r) => normalizeAsin(r?.asin))
      .filter((a) => a && isValidAsinTag(a)),
  )
  const overlapAsins = []
  const seenOverlap = new Set()
  for (const a of parsed) {
    const na = normalizeAsin(a)
    if (!isValidAsinTag(na) || seenOverlap.has(na)) continue
    if (previewAsinSet.has(na) || isAsinInSelectedTable(na)) {
      seenOverlap.add(na)
      overlapAsins.push(na)
    }
  }
  if (overlapAsins.length) {
    message.warning(
      t("seller.cpcCreate.msgPasteAsinAlreadyInHitList", {
        list: formatAsinListForPasteHint(overlapAsins),
      }),
    )
  }
  mergeParsedAsinsIntoDraft(parsed)
  asinSearchValue.value = ""
  if (asinSearchTimer) clearTimeout(asinSearchTimer)
  const asinsParam = parsed.slice(0, MAX_ASINS).join(",")
  void fetchSearchResults(asinsParam,'paste')
}

const onAsinDraftBlur = () => {

  asinDraftTags.value = asinDraftTags.value.filter((t) =>
    isValidAsinTag(extractAsinFromDraftTag(t)),
  )
  syncDraftTagRowTracking()
}

/** 点击输入行、命中列表、Select 下拉层以外时收起下方搜索命中列表 */
const onDocumentMousedownAsinSearchHits = (e) => {
  if (!searchResults.value.length || !showAsinSearchHitList.value) return
  const elTarget = e.target
  if (!(elTarget instanceof Node)) return
  if (asinSearchInputRowRef.value?.contains(elTarget)) return
  if (asinSearchHitsRef.value?.contains(elTarget)) return
  if (elTarget.closest?.(".ant-select-dropdown")) return
  showAsinSearchHitList.value = false
}

const addProductFromSearch = (row) => {
  const rowId = String(row?.id ?? "")
  const asin = normalizeAsin(row?.asin)
  if (!isValidAsinTag(asin)) {
    message.warning(t("seller.cpcCreate.msgInvalidAsin"))
    return
  }
  if (isAsinInSelectedTable(asin)) {
    message.warning(t("seller.cpcCreate.msgAsinAlreadyInSelected"))
    asinSearchValue.value = ""
    // searchResults.value = []
    return
  }
  const selectedAsinSet = new Set(
    (selectedProducts.value || []).map((p) => normalizeAsin(p?.asin)).filter(Boolean),
  )
  const nextDraftTagLabel = formatDraftTagLabel(row)
  const nextDraftLabelKey = normalizeDraftTagLabel(nextDraftTagLabel)
  const draftAsins = new Set(
    asinDraftTags.value
      .map((t) => extractAsinFromDraftTag(t))
      .filter((a) => a && isValidAsinTag(a) && !selectedAsinSet.has(a)),
  )
  if (rowId && draftSearchRowIds.value.has(rowId)) {
    message.warning(t("seller.cpcCreate.msgAsinAlreadyInInput"))
    return
  }
  if (selectedProducts.value.length + draftAsins.size >= MAX_ASINS) {
    message.error(t("seller.cpcCreate.msgMaxAsins", { max: MAX_ASINS }))
    return
  }
  asinDraftTags.value = [...asinDraftTags.value, nextDraftTagLabel]
  if (rowId) {
    draftSearchRowIds.value.add(rowId)
    draftTagLabelToRowId.value[nextDraftLabelKey] = rowId
  }
  asinSearchValue.value = ""
  // message.success(t("seller.cpcCreate.msgAddedToInputList"))
}

const removeSelectedProduct = (record) => {
  if (isLockedCampaignProduct(record)) return
  const asin = normalizeAsin(record?.asin)
  if (asin) {
    selectedProducts.value = selectedProducts.value.filter(
      (p) => normalizeAsin(p?.asin) !== asin,
    )
    return
  }
  const id = record?.id ?? record?.productId
  selectedProducts.value = selectedProducts.value.filter(
    (p) => (p?.id ?? p?.productId) !== id,
  )
}

const resolveProductByTag = async (tag) => {
  const asinQuery = extractAsinFromDraftTag(tag)
  if (!asinQuery) return null
  const res = await productsApi.getProductList({
    title: asinQuery,
    page: 1,
    size: 30,
  })
  if (!res?.success || !res.data?.data?.length) return null
  const list = res.data.data
  const exact = list.find((p) => normalizeAsin(p.asin) === asinQuery)
  return exact || list[0]
}

const addDraftTagsToSelected = () => {
  if (!asinDraftTags.value.length) {
    message.warning(t("seller.cpcCreate.msgEnterAsinToAdd"))
    return
  }
  const onlyAssociateEnabled = !form.attributionCpcEnabled && form.associateCpcEnabled
  const tags = [...asinDraftTags.value]
  const resultById = new Map(
    (searchResults.value || [])
      .filter((row) => row?.id !== undefined && row?.id !== null && row?.id !== "")
      .map((row) => [String(row.id), row]),
  )
  const resultByAsin = new Map(
    (searchResults.value || [])
      .filter((row) => row?.asin)
      .map((row) => [normalizeAsin(row.asin), row]),
  )
  const selectedRowIds = new Set(
    (selectedProducts.value || [])
      .map((row) => String(row?.id ?? row?.productId ?? ""))
      .filter(Boolean),
  )
  const nextRows = []
  const unmatched = []
  const inactiveAssociateAsins = []
  const remainingSlots = Math.max(0, MAX_ASINS - selectedProducts.value.length)
  let limitReached = remainingSlots === 0

  for (const raw of tags) {
    const labelKey = normalizeDraftTagLabel(raw)
    let rowId = String(draftTagLabelToRowId.value[labelKey] ?? "")
    let row = rowId ? resultById.get(rowId) : null
    // Fallback for copied/pasted tags without row-id mapping.
    if (!row) {
      const asin = extractAsinFromDraftTag(raw)
      const fallbackRow = resultByAsin.get(asin)
      if (fallbackRow?.id !== undefined && fallbackRow?.id !== null && fallbackRow?.id !== "") {
        rowId = String(fallbackRow.id)
        row = fallbackRow
        draftTagLabelToRowId.value[labelKey] = rowId
      }
    }
    if (!rowId || !row) {
      unmatched.push(raw)
      continue
    }
    if (selectedRowIds.has(rowId)) continue
    if (onlyAssociateEnabled) {
      const associateStatus = String(row?.associateStatus ?? "").trim().toLowerCase()
      if (associateStatus === "inactive") {
        inactiveAssociateAsins.push(normalizeAsin(row?.asin || extractAsinFromDraftTag(raw)))
        continue
      }
    }
    if (nextRows.length >= remainingSlots) {
      limitReached = true
      break
    }
    selectedRowIds.add(rowId)
    draftSearchRowIds.value.add(rowId)
    nextRows.push(row)
  }
  if (nextRows.length) {
    selectedProducts.value = [...selectedProducts.value, ...nextRows]
    asinDraftTags.value = []
    draftSearchRowIds.value.clear()
    draftTagLabelToRowId.value = {}
    searchResults.value = []
    asinSearchValue.value = ""
    message.success(t("seller.cpcCreate.msgAddedProductsCount", { count: nextRows.length }))
  } else if (unmatched.length && unmatched.length === tags.length) {
    message.warning(t("seller.cpcCreate.msgNoMatchingAsins"))
  } else if (unmatched.length) {
    message.warning(t("seller.cpcCreate.msgSomeAsinsUnmatched"))
  }
  if (inactiveAssociateAsins.length) {
    message.warning(
      t("seller.cpcCreate.msgInactiveAssociateAsins", {
        list: [...new Set(inactiveAssociateAsins.filter(Boolean))].join(", "),
      }),
    )
  }

  if (limitReached) {
    message.error(t("seller.cpcCreate.msgMaxAsins", { max: MAX_ASINS }))
  }
}

const form = reactive({
  title: "",
  totalBudget: "",
  publisherTotalCap: "",
  publisherDailyCap: "",
  startDate: null,
  endDate: null,
  attributionCpcUnitPrice: "",
  associateCpcUnitPrice: "",
  attributionCpcEnabled: true,
  associateCpcEnabled: false,
  productIds: [],
  publisherInvites: [],
  status: "",
})

const step1Errors = reactive({
  title: "",
  totalBudget: "",
  publisherTotalCap: "",
  publisherDailyCap: "",
  startDate: "",
  endDate: "",
  linkType: "",
  attributionCpcUnitPrice: "",
  associateCpcUnitPrice: "",
})

watch(
  () => form.title,
  (val) => {
    if (String(val || "").trim()) step1Errors.title = ""
  },
)

watch(
  () => form.totalBudget,
  (val) => {
    if (parsePositiveAmount(val) != null) step1Errors.totalBudget = ""
  },
)

watch(
  () => form.publisherTotalCap,
  (val) => {
    if (parsePositiveAmount(val) != null) step1Errors.publisherTotalCap = ""
  },
)

watch(
  () => form.publisherDailyCap,
  (val) => {
    if (parsePositiveAmount(val) != null) step1Errors.publisherDailyCap = ""
  },
)

watch(
  () => form.startDate,
  (val) => {
    if (val) step1Errors.startDate = ""
    if (form.endDate && moment(form.endDate).isAfter(moment(val), "day")) {
      step1Errors.endDate = ""
    }
  },
)

watch(
  () => form.endDate,
  (val) => {
    if (!val) return
    if (!form.startDate) {
      step1Errors.endDate = ""
      return
    }
    if (moment(val).isAfter(moment(form.startDate), "day")) {
      step1Errors.endDate = ""
    }
  },
)

watch(
  () => [form.attributionCpcEnabled, form.associateCpcEnabled],
  ([aEnabled, sEnabled]) => {
    if (aEnabled || sEnabled) step1Errors.linkType = ""
  },
)

watch(
  () => form.attributionCpcUnitPrice,
  (val) => {
    if (!form.attributionCpcEnabled) {
      step1Errors.attributionCpcUnitPrice = ""
      return
    }
    if (isValidCpcAmount(val)) step1Errors.attributionCpcUnitPrice = ""
  },
)

watch(
  () => form.associateCpcUnitPrice,
  (val) => {
    if (!form.associateCpcEnabled) {
      step1Errors.associateCpcUnitPrice = ""
      return
    }
    if (isValidCpcAmount(val)) step1Errors.associateCpcUnitPrice = ""
  },
)

const goCpc = () => {
  router.push("/seller/cpc")
}

const prevStep = () => {
  if (currentStep.value > 0) currentStep.value -= 1
}

const nextFromAsinStep = async () => {
  if (!selectedProducts.value.length) {
    message.error(t("seller.cpcCreate.msgAddAtLeastOneAsin"))
    return
  }
  form.productIds = selectedProducts.value
    .map((item) => item.productId ?? item.id)
    .filter((id) => id !== undefined && id !== null && id !== "")
  if (pageMode.value === "edit" && editCampaignId.value) {
    try {
      const res = await sellerCpcApi.setCpcCampaignsEditStep2({
        campaignId: editCampaignId.value,
        productIdList: form.productIds,
      })
      if (!res?.success) {
        message.error(res?.error || t("seller.cpcCreate.msgFailedSaveStep2"))
        return
      } else {
        message.success(t("seller.cpcCreate.msgStep2Saved"))
        currentStep.value = 2
      }
    } catch {
      message.error(t("seller.cpcCreate.msgFailedSaveStep2"))
      return
    }
  } else {
    currentStep.value = 2
  }
}

const toOptionalNumber = (value) => {
  const raw = String(value ?? "").trim()
  if (!raw) return undefined
  const n = Number(raw)
  return Number.isFinite(n) ? n : undefined
}

const getResolvedPublisherCap = (id, key) => {
  const budget = publisherBudgetById[String(id)] || {}
  const value =
    key === 'publisherTotalCap'
      ? (budget.publisherTotalCap ?? '')
      : (budget.publisherDailyCap ?? '')
  const num = toOptionalNumber(value)
  if (num !== undefined) return num
  return key === 'publisherTotalCap'
    ? toOptionalNumber(form.publisherTotalCap)
    : toOptionalNumber(form.publisherDailyCap)
}

const formatBudgetAmount = (value) => Number(value ?? 0).toFixed(2)

const estimatedDailyBudget = computed(() => {
  let total = 0
  for (const id of allSelectedPublisherIds.value) {
    const cap = getResolvedPublisherCap(id, 'publisherDailyCap')
    if (cap != null) total += cap
  }
  return total
})

const estimatedMaxBudget = computed(() => {
  let total = 0
  for (const id of allSelectedPublisherIds.value) {
    const cap = getResolvedPublisherCap(id, 'publisherTotalCap')
    if (cap != null) total += cap
  }
  return total
})

const submitCampaign = async () => {
  if (!allSelectedPublisherIds.value.size) {
    message.error(t("seller.cpcCreate.msgSelectOnePublisher"))
    return
  }
  clearPublisherBudgetErrors()
  const isEditMode = pageMode.value === "edit" && editCampaignId.value
  let hasPublisherBudgetErrors = false

  const publisherInvites = [...allSelectedPublisherIds.value].map((id) => {
    const budget = publisherBudgetById[String(id)] || {}
    const totalCapValue = String(
      budget.publisherTotalCap ?? budget.max ?? "",
    ).trim()
    const dailyCapValue = String(
      budget.publisherDailyCap ?? budget.daily ?? "",
    ).trim()
    let totalCapNum = toOptionalNumber(totalCapValue)
    let dailyCapNum = toOptionalNumber(dailyCapValue)
    if (isEditMode) {
      const originalTotalCap = toOptionalNumber(
          originalPublisherBudgetById[String(id)]?.publisherTotalCap,
        )
        if (originalTotalCap !== undefined && totalCapNum < originalTotalCap) {
          setPublisherBudgetError(
            id,
            "publisherTotalCap",
            t("seller.cpcCreate.msgCannotLowerThanCurrent"),
          )
          hasPublisherBudgetErrors = true
        }
     
//         publisherTotalCap
// publisherDailyCap
//         if()
      // if (totalCapNum === undefined) {
      //   setPublisherBudgetError(id, "publisherTotalCap", "Please enter max budget cap.")
      //   hasPublisherBudgetErrors = true
      // } else {
      //   const originalTotalCap = toOptionalNumber(
      //     originalPublisherBudgetById[String(id)]?.publisherTotalCap,
      //   )
      //   if (originalTotalCap !== undefined && totalCapNum < originalTotalCap) {
      //     setPublisherBudgetError(
      //       id,
      //       "publisherTotalCap",
      //       `Cannot be lower than current.`,
      //     )
      //     hasPublisherBudgetErrors = true
      //   }
      // }
      const originalDailyCap = toOptionalNumber(
          originalPublisherBudgetById[String(id)]?.publisherDailyCap,
        )
        if (originalDailyCap !== undefined && dailyCapNum < originalDailyCap) {
          setPublisherBudgetError(
            id,
            "publisherDailyCap",
            t("seller.cpcCreate.msgCannotLowerThanCurrent"),
          )
          hasPublisherBudgetErrors = true
        }
       
        
      // if (dailyCapNum === undefined) {
      //   setPublisherBudgetError(id, "publisherDailyCap", "Please enter daily budget cap.")
      //   hasPublisherBudgetErrors = true
      // } else {
      //   const originalDailyCap = toOptionalNumber(
      //     originalPublisherBudgetById[String(id)]?.publisherDailyCap,
      //   )
      //   if (originalDailyCap !== undefined && dailyCapNum < originalDailyCap) {
      //     setPublisherBudgetError(
      //       id,
      //       "publisherDailyCap",
      //       `Cannot be lower than current.`,
      //     )
      //     hasPublisherBudgetErrors = true
      //   }
      // }
    }
    if(dailyCapNum !== undefined && dailyCapNum < form.publisherDailyCap) {
          setPublisherBudgetError(
            id,
            "publisherDailyCap",
            t("seller.cpcCreate.msgCannotLowerThanValue", { value: form.publisherDailyCap }),
          )
          hasPublisherBudgetErrors = true
        }
   if (dailyCapNum === undefined) {
          dailyCapNum = toOptionalNumber(form.publisherDailyCap)
        }
   if(totalCapNum !== undefined && totalCapNum < form.publisherTotalCap) {
          setPublisherBudgetError(
            id,
            "publisherTotalCap",
            t("seller.cpcCreate.msgCannotLowerThanValue", { value: form.publisherTotalCap }),
          )
          hasPublisherBudgetErrors = true
        }
   if (totalCapNum === undefined) {
          totalCapNum = toOptionalNumber(form.publisherTotalCap)
   }
    return {
      publisherId: toOptionalNumber(id),
      publisherTotalCap: totalCapNum,
      publisherDailyCap: dailyCapNum,
    }
  })
  if (hasPublisherBudgetErrors) {
    message.error(t("seller.cpcCreate.msgFixPublisherBudgetErrors"))
    return
  }

  const payload = {
    marketplace: CURRENCY_MAPPER[countryCode].host,
    ...form,
    productIds: selectedProducts.value
      .map((item) => item.productId ?? item.id)
      .filter((id) => id !== undefined && id !== null && id !== ""),
    publisherInvites,
  }
  if (payload.startDate) {
    payload.startDateTimestamp = moment(moment(payload.startDate).format("YYYY-MM-DD") + ' 00:00:00').valueOf()
  }
  if (payload.endDate) {
    payload.endDateTimestamp = moment(moment(payload.endDate).format("YYYY-MM-DD") + ' 23:59:59').valueOf()
  }
  delete payload.startDate
  delete payload.endDate

  try {
    const isEditMode = pageMode.value === "edit" && editCampaignId.value
    const reqPayload = isEditMode
      ? { publisherInvites: publisherInvites, campaignId: editCampaignId.value, }
      : payload
    const res = isEditMode
      ? await sellerCpcApi.setCpcCampaignsEditStep3(reqPayload)
      : await sellerCpcApi.createCpcCampaign(reqPayload)
    if (res?.success) {
      message.success(
        isEditMode
          ? t("seller.cpcCreate.msgCampaignUpdated")
          : t("seller.cpcCreate.msgCampaignCreated"),
      )
      goCpc()
      return
    }
    message.error(
      res?.error ||
        (isEditMode
          ? t("seller.cpcCreate.msgFailedUpdateCampaign")
          : t("seller.cpcCreate.msgFailedCreateCampaign")),
    )
  } catch {
    message.error(
      pageMode.value === "edit"
        ? t("seller.cpcCreate.msgFailedUpdateCampaign")
        : t("seller.cpcCreate.msgFailedCreateCampaign"),
    )
  }
}

const parsePositiveAmount = (value) => {
  const n = parseFloat(String(value).trim())
  if (Number.isNaN(n) || n <= 0) return null
  return n
}

/** 编辑保存 Step1：表单预算低于详情加载值时，改回加载时的值再提交 */
const coerceEditStep1BudgetsToLoadedCaps = () => {
  if (pageMode.value !== "edit" || !editCampaignId.value) return
  const pairs = [
    ["totalBudget", editLoadedTotalBudget],
    ["publisherTotalCap", editLoadedPublisherTotalCap],
    ["publisherDailyCap", editLoadedPublisherDailyCap],
  ]
  for (const [key, loadedRef] of pairs) {
    const loaded = loadedRef.value
    if (loaded == null || !Number.isFinite(loaded)) continue
    const cur = parsePositiveAmount(form[key])
    if (cur == null) continue
    if (cur < loaded) form[key] = loaded
  }
}

const syncEditLoadedStep1BudgetsFromForm = () => {
  const tb = parsePositiveAmount(form.totalBudget)
  const tc = parsePositiveAmount(form.publisherTotalCap)
  const dc = parsePositiveAmount(form.publisherDailyCap)
  if (tb != null) editLoadedTotalBudget.value = tb
  if (tc != null) editLoadedPublisherTotalCap.value = tc
  if (dc != null) editLoadedPublisherDailyCap.value = dc
}

const isValidCpcAmount = (value) => {
  const text = String(value ?? "").trim()
  if (!text) return false
  return /^(?:\d+)(?:\.\d)?$/.test(text) && Number(text) > 0
}

const validateCpcField = (field) => {
  const value = form[field]
  if (value === "" || value === null || value === undefined) return
  if (!isValidCpcAmount(value)) {
    message.error(t("seller.cpcCreate.msgInvalidCpcAmount"))
  }
}

const onLinkTypeToggle = (type, checked) => {
  if (isActiveEditCampaign() && !checked && lockedInitialLinkTypes[type]) {
    nextTick(() => {
      if (type === "attribution") {
        form.attributionCpcEnabled = true
      } else {
        form.associateCpcEnabled = true
      }
    })
    message.warning(t("seller.cpcCreate.msgActiveCannotDisableLink"))
    return
  }
  if (isActiveEditCampaign()) return
  const otherEnabled =
    type === "attribution"
      ? form.associateCpcEnabled
      : form.attributionCpcEnabled

  if (!otherEnabled) {
    nextTick(() => {
      if (type === "attribution") {
        form.attributionCpcEnabled = true
      } else {
        form.associateCpcEnabled = true
      }
    })
    message.warning(t("seller.cpcCreate.msgAtLeastOneLinkType"))
  }
}

/** a-date-picker（antdv4）disabledDate 传入 Dayjs，与 moment 直接比较会失效，统一按毫秒转 moment */
const pickerDayToMomentStart = (d) => {
  if (d == null || d === "") return null
  let m
  if (typeof moment.isMoment === "function" && moment.isMoment(d)) {
    m = d.clone().startOf("day")
  } else if (typeof d?.valueOf === "function") {
    const v = d.valueOf()
    if (typeof v === "number" && !Number.isNaN(v)) m = moment(v).startOf("day")
  }
  if (!m || !m.isValid()) m = moment(d).startOf("day")
  return m.isValid() ? m : null
}

const disablePastDates = (current) => {
  const cur = pickerDayToMomentStart(current)
  if (!cur || !cur.isValid()) return false
  return cur.isBefore(moment().startOf("day"), "day")
}

const disableEndDate = (current) => {
  const cur = pickerDayToMomentStart(current)
  if (!cur || !cur.isValid()) return false
  const todayStart = moment().startOf("day")
  if (cur.isBefore(todayStart, "day")) return true
  const isEditMode = pageMode.value === "edit" && !!editCampaignId.value
  // 30-day limit applies in edit mode only.
  if (isEditMode) {
    const minEndDay = todayStart.clone().add(30, "days")
    if (cur.isBefore(minEndDay, "day")) return true
  }
  if (!form.startDate) return false
  const startDay = pickerDayToMomentStart(form.startDate)
  if (!startDay) return false
  /** 结束日须严格晚于开始日（按自然日） */
  return !cur.isAfter(startDay, "day")
}

const nextStep = async () => {
  Object.keys(step1Errors).forEach((key) => {
    step1Errors[key] = ""
  })

  const title = String(form.title || "").trim()
  if (!title) {
    step1Errors.title = t("seller.cpcCreate.errTitleRequired")
  }

  const totalBudget = parsePositiveAmount(form.totalBudget)
  if (totalBudget == null) {
    step1Errors.totalBudget = t("seller.cpcCreate.errTotalBudget")
  }

  const totalCap = parsePositiveAmount(form.publisherTotalCap)
  if (totalCap == null) {
    step1Errors.publisherTotalCap = t("seller.cpcCreate.errPublisherTotalCap")
  }

  const dailyCap = parsePositiveAmount(form.publisherDailyCap)
  if (dailyCap == null) {
    step1Errors.publisherDailyCap = t("seller.cpcCreate.errPublisherDailyCap")
  }

  if (!form.startDate || !form.endDate) {
    if (!form.startDate) step1Errors.startDate = t("seller.cpcCreate.errStartDate")
    if (!form.endDate) step1Errors.endDate = t("seller.cpcCreate.errEndDate")
  }
  if (form.startDate && form.endDate) {
    const start = pickerDayToMomentStart(form.startDate)
    const end = pickerDayToMomentStart(form.endDate)
    if (!start || !end) {
      step1Errors.endDate = step1Errors.endDate || t("seller.cpcCreate.errDatesInvalid")
    } else if (isActiveEditCampaign()) {
      const maxEndDay = moment().startOf("day").add(30, "days")
     
    } else if (pageMode.value === "edit" && editCampaignId.value) {
      const minEndDay = moment().startOf("day").add(30, "days")
      // if (end.isBefore(minEndDay, "day")) {
      //   step1Errors.endDate =
      //     "End date must be at least 30 days after today."
      // }
    }
  }

  if (!form.attributionCpcEnabled && !form.associateCpcEnabled) {
    step1Errors.linkType = t("seller.cpcCreate.errLinkTypeRequired")
  }

  if (form.attributionCpcEnabled && !isValidCpcAmount(form.attributionCpcUnitPrice)) {
    step1Errors.attributionCpcUnitPrice = t("seller.cpcCreate.errCpcAmount")
  }

  if (form.associateCpcEnabled && !isValidCpcAmount(form.associateCpcUnitPrice)) {
    step1Errors.associateCpcUnitPrice = t("seller.cpcCreate.errCpcAmount")
  }

  if (Object.values(step1Errors).some(Boolean)) {
    message.error(t("seller.cpcCreate.msgCompleteRequired"))
    return
  }

  if (pageMode.value === "edit" && editCampaignId.value) {
    coerceEditStep1BudgetsToLoadedCaps()
    try {
      const startDateTimestamp = moment(
        `${moment(form.startDate).format("YYYY-MM-DD")} 00:00:00`,
      ).valueOf()
      const endDateTimestamp = moment(
        `${moment(form.endDate).format("YYYY-MM-DD")} 23:59:59`,
      ).valueOf()
      const res = await sellerCpcApi.setCpcCampaignsEditStep1({
        campaignId: editCampaignId.value,
        title: String(form.title || "").trim(),
        marketplace: form.marketplace || CURRENCY_MAPPER[countryCode].host,
        totalBudget: Number(form.totalBudget),
        publisherTotalCap: Number(form.publisherTotalCap),
        publisherDailyCap: Number(form.publisherDailyCap),
        startDateTimestamp,
        endDateTimestamp,
        attributionCpcEnabled: !!form.attributionCpcEnabled,
        attributionCpcUnitPrice: Number(form.attributionCpcUnitPrice),
        associateCpcEnabled: !!form.associateCpcEnabled,
        associateCpcUnitPrice: Number(form.associateCpcUnitPrice),
      })
      if (!res?.success) {
        message.error(res?.error || t("seller.cpcCreate.msgFailedSaveStep1"))
        return
      } else {
        message.success(t("seller.cpcCreate.msgStep1Saved"))
        syncEditLoadedStep1BudgetsFromForm()
        currentStep.value = 1
      }
    } catch {
      message.error(t("seller.cpcCreate.msgFailedSaveStep1"))
      return
    }
  } else {
    currentStep.value = 1

  }

}

const isLockedCampaignProduct = (item) =>
  isActiveEditCampaign() &&
  lockedExistingProductIds.value.has(String(item?.productId ?? item?.id ?? ""))

const mapProductsForTable = (products = []) =>
  (products || []).map((item) => ({
    id: item.productId ?? item.id,
    productId: item.productId ?? item.id,
    asin: item.asin || "",
    productImage: item.imageUrl || "",
    productTitle: item.productTitle || "",
    // keep table-compatible placeholders for current columns/components
    brandName: item.brandName || "-",
    amazonSellerName: item.amazonSellerName || item.amazonName || "-",
    productDeals: item.productDeals || [],
    price: item.price ?? item.listPrice ?? "",
    currentPrice: item.currentPrice ?? item.listPrice ?? "",
    currencySymbol: CURRENCY_DATA_MAPPER[item.currency],
    status: item.status || "",
  }))

const applyPublisherInvites = (publisherInvites = []) => {
  allSelectedPublisherIds.value = new Set()
  clearOriginalPublisherBudgets()
  for (const invite of publisherInvites || []) {
    const id = normalizePublisherId(invite?.publisherId)
    if (id === undefined || id === null || id === "") continue
    allSelectedPublisherIds.value.add(id)
    ensureBudgetRow(id)
    const totalCap = invite.publisherTotalCap ?? ""
    const dailyCap = invite.publisherDailyCap ?? ""
    publisherBudgetById[String(id)].publisherTotalCap = totalCap
    publisherBudgetById[String(id)].publisherDailyCap = dailyCap
    originalPublisherBudgetById[String(id)] = {
      publisherTotalCap: totalCap,
      publisherDailyCap: dailyCap,
    }
  }
  syncPublisherSelectionAfterLoad()
}

const loadEditProducts = async () => {
  if (!editCampaignId.value) return []
  try {
    const res = await sellerCpcApi.getCpcCampaignsProducts({
      campaignId: editCampaignId.value,
    })
    if (!res?.success) return []
    const rawList = Array.isArray(res?.data?.data)
      ? res.data.data
      : Array.isArray(res?.data)
        ? res.data
        : []
    return mapProductsForTable(rawList)
  } catch {
    return []
  }
}

const loadEditCampaignData = async () => {
  if (pageMode.value !== "edit" || !editCampaignId.value) return
  editLoadedTotalBudget.value = null
  editLoadedPublisherTotalCap.value = null
  editLoadedPublisherDailyCap.value = null
  try {
    const res = await sellerCpcApi.getCpcCampaignsById({
      campaignId: editCampaignId.value,
    })
    if (!res?.success || !res?.data) {
      message.error(res?.error || t("seller.cpcCreate.msgFailedLoadCampaign"))
      return
    }
    const data = res.data
    form.status = data.status
    form.marketplace = data.marketplace
    form.title = data.title || ""
    form.totalBudget = data.totalBudget ?? ""
    form.publisherTotalCap = data.publisherTotalCap ?? ""
    form.publisherDailyCap = data.publisherDailyCap ?? ""
    editLoadedTotalBudget.value = parsePositiveAmount(data.totalBudget)
    editLoadedPublisherTotalCap.value = parsePositiveAmount(data.publisherTotalCap)
    editLoadedPublisherDailyCap.value = parsePositiveAmount(data.publisherDailyCap)
    form.startDate = data.startDateTimestamp ? moment(data.startDateTimestamp) : null
    form.endDate = data.endDateTimestamp ? moment(data.endDateTimestamp) : null
    form.attributionCpcEnabled = !!data.attributionCpcEnabled
    form.associateCpcEnabled = !!data.associateCpcEnabled
    lockedInitialLinkTypes.attribution = !!data.attributionCpcEnabled
    lockedInitialLinkTypes.associate = !!data.associateCpcEnabled
    form.attributionCpcUnitPrice = data.attributionCpcUnitPrice ?? ""
    form.associateCpcUnitPrice = data.associateCpcUnitPrice ?? ""
    form.publisherInvites = data.publisherInvites
    console.log(form,'formform')
    const detailProducts = Array.isArray(data.products) ? data.products : []
    selectedProducts.value = mapProductsForTable(detailProducts)
    lockedExistingProductIds.value = new Set(
      selectedProducts.value
        .map((item) => String(item?.productId ?? item?.id ?? ""))
        .filter(Boolean),
    )


    applyPublisherInvites(data.publisherInvites || [], {
      publisherTotalCap: data.publisherTotalCap,
      publisherDailyCap: data.publisherDailyCap,
    })
  } catch {
    editLoadedTotalBudget.value = null
    editLoadedPublisherTotalCap.value = null
    editLoadedPublisherDailyCap.value = null
    message.error(t("seller.cpcCreate.msgFailedLoadCampaign"))
  }
}

onMounted(() => {
  loadEditCampaignData()
  document.addEventListener("mousedown", onDocumentMousedownAsinSearchHits)
})

onUnmounted(() => {
  document.removeEventListener("mousedown", onDocumentMousedownAsinSearchHits)
})
</script>

<style scoped lang="less">
.iconAsc{
  transform: rotate(180deg);
}
.paixuText{
  margin-left: 4px;
}
:deep(.footer){
  display: none !important;
}
.form-title {
  font-family: Sora;
  font-weight: 600;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: 0.5px;
  color: rgba(15, 6, 41, 1);
  padding: 16px 0;
  border-bottom: 1px solid rgba(232, 229, 237, 1);
}

.form-content {
  padding-top: 16px;
  padding-bottom: 8px;
}

.cpc-create {
  padding: 0 24px;
  padding-top: 0;
}

.breadcrumb-line {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 8px;
}

.crumb {
  cursor: pointer;
}

.crumb.current {
  color: #111827;
  cursor: default;
}

.divider {
  margin: 0 6px;
}

.title {
  margin: 0 0 12px;
  color: #374151;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
}

.panel {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 0 24px;
  box-shadow: var(--section-box-shadow-6);
}

.steps {
  margin-bottom: 18px;
  --cpc-step-active: rgba(131, 92, 242, 1);
  --cpc-step-active-soft: rgba(105, 74, 194, 0.22);
  --cpc-step-wait-border: #e5e7eb;
  --cpc-step-wait-text: #9ca3af;
  --cpc-step-finish: rgba(105, 74, 194, 0.85);
  /* 步骤间横杠：浅灰细线（与圆点、标题视觉对齐） */
  --cpc-step-line: #e5e7eb;

  /* steps 与 .steps 在同一根节点，不能用 .steps .ant-steps 后代选择器 */
  &.ant-steps {
    overflow: visible;
  }

  // :deep(.ant-steps-item) {
  //   overflow: visible;
  // }

  :deep(.ant-steps-item-container) {
    outline: none;
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 5px;
  }

  /* 自定义 #icon 只有数字时，避免图标区宽度被压窄成竖条，保持正圆 */
  :deep(.ant-steps-item-icon) {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    min-height: 32px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    line-height: 1 !important;
  }

  :deep(.ant-steps-item-icon .cpc-step-index) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 16px;
    line-height: 1;
  }

  /* 激活：紫底白字 + 外圈光晕 */
  :deep(.ant-steps-item-process .ant-steps-item-icon) {
    background: var(--cpc-step-active) !important;
    border-color: var(--cpc-step-active) !important;
    color: #fff !important;
    box-shadow: 0 0 0 5px var(--cpc-step-active-soft);
  }

  :deep(.ant-steps-item-process .ant-steps-item-icon .ant-steps-icon) {
    color: #fff !important;
  }

  :deep(.ant-steps-item-process .ant-steps-item-icon span) {
    color: #fff !important;
  }

  :deep(.ant-steps-item-process.ant-steps-item-active .ant-steps-item-icon) {
    box-shadow: 0 0 0 5px var(--cpc-step-active-soft);
  }

  /* 未进行：浅灰描边 */
  :deep(.ant-steps-item-wait .ant-steps-item-icon) {
    background: #fff !important;
    border-color: var(--cpc-step-wait-border) !important;
    color: var(--cpc-step-wait-text) !important;
  }

  :deep(.ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon) {
    color: var(--cpc-step-wait-text) !important;
  }

  /* 已完成 */
  :deep(.ant-steps-item-finish .ant-steps-item-icon) {
    background: #fff !important;
    border-color: var(--cpc-step-finish) !important;
    color: var(--cpc-step-finish) !important;
  }

  :deep(.ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon) {
    color: var(--cpc-step-finish) !important;
  }

 

  :deep(.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after),
  :deep(.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after),
  :deep(.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after) {
    height: 2px !important;
    border-radius: 999px !important;
    background-color: var(--cpc-step-line) !important;
  }

  &.ant-steps-horizontal:not(.ant-steps-label-vertical) {
    /* 水平步骤：连线与圆心大致对齐 */
    :deep(.ant-steps-item-tail) {
      top: 16px !important;
      padding: 0 !important;
    }

    /* 标题右侧横线（与 Ant 的 title::after 同一节点，需压过 cssinjs） */
    :deep(.ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after) {
      height: 2px !important;
      border-radius: 999px !important;
      // background: var(--cpc-step-line) !important;
    }
  }

  :deep(.ant-steps-item-wait .ant-steps-item-title),
  :deep(.ant-steps-item-finish .ant-steps-item-title) {
    font-family: Sora, sans-serif !important;
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 16px !important;

    letter-spacing: 0 !important;
  }

  :deep(.ant-steps-item-wait .ant-steps-item-title) {
    color: var(--cpc-step-wait-text) !important;
  }

  :deep(.ant-steps-item-finish .ant-steps-item-title) {
    color: rgba(15, 6, 41, 0.55) !important;
  }

  :deep(.ant-steps-item-process .ant-steps-item-title) {
    color: var(--cpc-step-active) !important;
    font-family: Sora, sans-serif !important;
    font-weight: 500 !important;
    font-style: normal !important;
    font-size: 16px !important;

    letter-spacing: 0 !important;
  }
}

.notice {
  background: #f2f3f5;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 18px;
  color: #4b5563;

  p {
    margin: 0;
    line-height: 1.6;
  }
}

.form {
  // max-width: 720px;
}

.title-input {
  height: 40px;
  width: 480px !important;
}

.title-input.budget-input {
  :deep(.ant-input-number-affix-wrapper) {
    height: 40px;
    display: flex;
    align-items: center;
  }

  :deep(.ant-input-number-input) {
    height: 39px;
    line-height: 39px;
    padding-top: 0;
    padding-bottom: 0;
    // text-align: center;
  }
}

.field-title {
  .title-input-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 8px;

    :deep(.ant-input) {
      flex: 1;
      min-width: 200px;
    }

  }
}

.field {
  margin-bottom: 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  label {
    font-family: Sora;
    font-weight: 500;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 1);

    small {
      margin-left: 4px;
      color: #9ca3af;
      font-weight: 400;
    }

    .label-required {
      color: #ff4d4f;
      margin-left: 2px;
      vertical-align: middle;
      line-height: 1;
    }
  }

  .small {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0.3px;

  }
}

.field-error-text {
  margin: 6px 0 0;
  color: #ff4d4f;
  font-size: 12px;
  line-height: 1.4;
}

.field-error {

  :deep(.ant-input),
  :deep(.ant-input-number),
  :deep(.ant-picker) {
    border-color: #ff4d4f !important;
    box-shadow: none !important;
  }
}

.with-suffix {
  position: relative;
  padding-right: 20px;
}

.suffix {
  position: absolute;
  right: 4px;
  bottom: 7px;
  color: #6b7280;
}

.tips {
  flex-shrink: 0;
  color: #9ca3af;
}

.cpc-platform-fee-box {
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f8f7fc;
}

.cpc-platform-fee-title {
  font-family: Sora;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: #0f0629;
}

.cpc-platform-fee-desc {
  margin-top: 4px;
  font-family: Sora;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.75);
}

.platform-fee-note {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  color: rgba(230, 130, 0, 1);
  padding-bottom: 25px;
  .icon-svg {
    width: 20px !important;
    height: 20px !important;
  }
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 800px;
}

.cpc-line {
  display: flex;
  align-items: center;
  gap: 12px;
  // margin-bottom: 10px;
  margin-top: 8px;
}

.item {
  display: flex;
  padding: 3px 4px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #f1f0f5;
  min-width: 111px;

  .icon {
    width: 20px !important;
    height: 20px !important;
  }

  .item-text {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
}

.line-label {
  width: 120px;
  color: #4b5563;
}

.actions {
  border-radius:0 0 8px 8px ;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  height: 64px;
  padding: 0 16px;
  margin-bottom: 2px;
  align-items: center;
  position: sticky;
  bottom: 0;
  z-index: 999;
  background-color: #fff;
  margin-top: 2px;
  box-shadow: var(--section-box-shadow-6);
}

.actions-one {
  display: flex;
  align-items: center;
  gap: 8px;
}
.actions-two{
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  flex: 1;
}

.publisher-summary-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;

}

.publisher-summary-item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.publisher-summary-label {
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: #0f0629;
  white-space: nowrap;
}

.publisher-summary-value {
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.9);
  white-space: nowrap;
}
.actions-split {
  justify-content: space-between;
  width: 100%;
}

.actions-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-back {
  border-color: #d1d5db;
  color: #374151;
  background: #f9fafb;

  &:hover {
    border-color: #9ca3af !important;
    color: #111827 !important;
    background: #f3f4f6 !important;
  }
}

.btn-cancel {
  border: none;
  background-color: var(--yellow-5);
  color: var(--yellow-4);

  &:hover {
    background-color: var(--yellow-1) !important;
    color: var(--yellow-4) !important;
  }
}

.step-placeholder {
  padding: 24px 0;
  color: #374151;

  p {
    margin: 0 0 8px;
  }

  .muted {
    color: #9ca3af;
    font-size: 14px;
  }
}

.step-asins {
  // max-width: 960px;
}



.publisher-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  margin-top: 32px;
}

.publisher-search {
  width: 260px;
  max-width: 100%;
}

.publisher-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 14px 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  background: #f8f7fc;
}

.publisher-filter-label {
  font-size: 14px;
  font-weight: 500;
  color: #0f0629;
  margin-bottom: 8px;
}

.publisher-segmented {
  // min-width: 280px;
}
// :deep(.ant-segmented) {
//     padding: 3px;
//     border-radius: 999px !important;
//     background: rgba(234, 232, 240, 1) !important;
//   }
.form{
  // .cpc-link-segmented {
  :deep(.ant-segmented) {
    padding: 3px;
    border-radius: 999px !important;
    background: rgba(234, 232, 240, 1) !important;
  }

  :deep(.ant-segmented-group) {
    gap: 0;
  }

  :deep(.ant-segmented-item) {
    min-width: 62px;
    border-radius: 999px;
    color: #6b7280;
    font-weight: 600;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    transition: all 0.2s ease;
  }

  :deep(.ant-segmented-item-selected) {
    background: #20b26b;
    color: #fff;
    box-shadow: none;
  }
}
// }


.cpc-link-segmented.is-off {
  :deep(.ant-segmented-item-selected) {
    background: #fff;
    color: #0f0629;
  }
}

.publisher-table {
  margin-bottom: 8px;

  :deep(.cpc-publisher-locked-select-tooltip-wrap) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 22px;
  }
}

.publisher-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.publisher-name {
  font-weight: 600;
  color: #374151;
}

.budget-cap-cell {
  min-width: 120px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.budget-display-value {
  font-family: Sora;
font-weight: 600;
font-style: SemiBold;
font-size: 14px;
leading-trim: NONE;
line-height: 19px;
letter-spacing: 0.4px;
color: rgba(15, 6, 41, 1);
}
.line-separator{
  color: rgba(87, 81, 105, 1);
}
.budget-edit-trigger {
  display: inline-flex;
  align-items: center;
}

.budget-edit-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.budget-edit-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  :deep(.anticon) {
    font-size: 18px;
  }
}

.budget-edit-btn.cancel {
  background: #f5f5f7;
  color: #9ca3af;
}

.budget-edit-btn.save {
  background: #7c5bff;
  color: #fff;
}

.budget-input {
  width: 120px;

  :deep(.ant-input) {
    border-color: #7c5bff;
    border-radius: 10px;
    height: 36px;
  }
}



.budget-input-error {
  :deep(.ant-input) {
    border-color: #ff4d4f !important;
    box-shadow: none !important;
  }
}

.budget-error-text {
  margin: 4px 0 0;
  color: #ff4d4f;
  font-size: 12px;
  line-height: 1.4;
}

.edit-budget-icon {
  color: rgba(87, 81, 105, 1);
  font-size: 14px;
}

.text-ellipsis-2 {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.actions-step3 .selected-publishers-count {
  font-family: Sora;
font-weight: 600;
font-style: SemiBold;
font-size: 14px;
leading-trim: NONE;
line-height: 19px;
letter-spacing: 0.4px;
color: rgba(15, 6, 41, 1);
}

.asin-input-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 16px;
}

.asin-tag-select-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 800px;
  max-width: 100%;
  min-width: 240px;

  /** 与 commission rule 中 artmisads-select 一致：下拉挂在本容器内，由样式隐藏空列表层 */
  :deep(.ant-select-dropdown) {
    display: none !important;
  }
}

.asin-tags-select {
  width: 100%;

  :deep(.ant-select-selector) {
    min-height: 90px;
    width: 100%;
    padding: 10px 12px;
    align-items: flex-start;
  }

  :deep(.ant-select-selection-overflow) {
    align-items: flex-start;
  }

  :deep(.ant-select-selection-placeholder) {
    position: absolute;
    top: 25%;
    color: #9ca3af;
  }

  :deep(.ant-select-selection-search-input) {
    height: 28px !important;
    line-height: 28px;
  }
}

.asin-search-spin {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}

.btn-add-list {
  flex-shrink: 0;
  align-self: flex-start;
  height: 40px;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.asin-paste-hint {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  color: rgba(230, 130, 0, 1);
  padding-top: 8px;
}

.asin-search-hits {
  width: 100%;
  box-sizing: border-box;
  margin-top: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
}

.asin-hit-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  color: #374151;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f9fafb;
  }

  /** 与已出现在 asinDraftTags 中的项同款的浅紫卡片样式 */
  &.is-in-draft {
    margin: 8px;
    padding: 7px 8px;
    min-height: 32px;
    box-sizing: border-box;
    font-family: Sora, system-ui, sans-serif;
    font-weight: 500;
    line-height: 1.25;
    color: rgba(15, 6, 41, 1);
    background: rgba(237, 233, 249, 1);
    // border: 1px solid rgba(15, 6, 41, 0.18);
    border-radius: 6px;

    &:hover {
      background: rgba(108, 61, 242, 0.08);
      // border-color: rgba(105, 74, 194, 0.35);
    }
  }
}

.asin-hit-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.asin-hit-row.is-in-draft .asin-hit-seller {
  color: rgba(15, 6, 41, 0.62);
  font-weight: 500;
}

.asin-hit-seller {
  color: #6b7280;
}

.asin-hit-add {
  color: #dc2626;
  font-weight: 500;

  &:hover {
    color: #b91c1c;
  }
}

.asin-hit-added {
  color: #9ca3af;
  font-size: 13px;
}

.selected-asins-title {
  margin: 24px 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.asin-table {
  :deep(.deal-cell) {
    display: flex;
    // flex-direction: column;
    gap: 8px;
  }
}

.deal-empty {
  color: #9ca3af;
}
.add-icon{
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.link-remove {
  border: 1px solid rgba(255, 195, 195, 1);
  background-color: rgba(253, 238, 236, 1);
  color: rgba(235, 78, 61, 1);
  padding: 5px 8px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-block;

  &:hover {
    background-color: rgba(253, 238, 236, 0.8);
  }
}

.link-remove.is-locked {
  border-color: #d1d5db;
  background-color: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;

  &:hover {
    background-color: #f3f4f6;
  }
}
</style>
